import styled from "styled-components";
import { navigation } from "./navigations";
import { NavigationItem } from "../../atoms/NavigationItem/NavigationItem";
import { useState } from "react";
import { NavigationCollapsable } from "../../atoms/NavigationItem/NavigationCollapsable";
import { Icon } from "../../atoms";
import { useTranslation } from "react-i18next";
import buildClassName from "../../../utils/buildClassName";

interface IOwnProps {
  onToggle: (param: string) => void;
}
/**
 * Main Wrapper Div
 */
const WrapperDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 48px;
  height: calc(100vh - 52px);
  transition: width 250ms ease-in-out 0.1ms;
  &.unfold {
    width: 165px;
    /* min-width: 150px;
    max-width: 170px; */
  }
  background-color: ${(theme: any) => theme.theme.bgColor3};
  .header-top {
    width: 100%;
    position: relative;
    height: 80%;
    // direction: ltr;
    overflow-y: scroll;
    overflow-x: hidden;
  }
  .header-bottom {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 20%;
    padding: 0 20px;
    img {
      transition: transform 0.3s ease-in-out, opacity 0.25s ease-in-out 0.1s;
    }
    .fold-unfold-title {
      color: ${(theme) => theme.theme.Light4};
    }
    &.fold {
      .fold-unfold-title {
        display: none;
      }
    }
    &.unfold {
      justify-content: space-between;
      flex-direction: row-reverse;
      img {
        transform: rotate(180deg);
      }
    }
  }
`;
/**
 * Navigations Uordred List
 */
const NavListGroup = styled.ul`
  padding: 0;
  margin: 0;
  display: flex;
  flex-flow: row wrap;
  // direction: rtl;
  /* height: 100%; */
`;
/**
 *
 * @constructor
 */
const DesktopSideBarMenu: React.FC<IOwnProps> = ({ onToggle }) => {
  const [isFolded, setIsFolded] = useState<"fold" | "unfold">("unfold");
  /**
   * Get All System Cryptos To Fill Menu
   */

  const { t, i18n } = useTranslation();
  const lng = i18n.language;
  const toggleFold = () => {
    const fold = isFolded === "unfold" ? "fold" : "unfold";
    setIsFolded(fold);
    onToggle(fold);
  };
  // document.body.dir = i18n.dir();
  return (
    <WrapperDiv className={isFolded} >
      <div className={buildClassName(isFolded, "header-top", "custom-scroll")}>
        <NavListGroup dir={i18n.dir()}>
          {navigation &&
            navigation.map((nav, index) => {
              if (nav.type === "item") {
                return (
                  <NavigationItem key={index} navItem={nav} isFold={isFolded} />
                );
              } else {
                return (
                  <NavigationCollapsable
                    key={index}
                    navItem={nav}
                    isFold={isFolded}
                  />
                );
              }
            })}
        </NavListGroup>
      </div>
      <div className={"header-bottom " + isFolded} onClick={toggleFold} dir={i18n.dir()}>
        <span className="fold-unfold-title ">{t("Fold Menu")}</span>
        {lng === "fa" ? 
          (<Icon name={"arrowfold"} width={"20px"} height={"20px"}/>)
          :
          (<Icon name={"arrowfoldEn"} width={"20px"} height={"20px"}/>)
        }
      </div>
    </WrapperDiv>
  );
};

export default DesktopSideBarMenu;
